import React, { useEffect, useCallback } from "react";
import { Container, Table, Col, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSuivieBlOnly } from "../../Redux/suivieBlReduce";


function DetailSuivieBl({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    const location = useParams();
    const [entities, setEntities] = React.useState([]);
    const [tete, setEntitieTete] = React.useState([]);
    const [loader, setLoader] = React.useState(true);

    const getSuivieBl = useCallback(
        async () => {
            var PrixProd = await dispatch(fetchSuivieBlOnly({ id: location.id }));
            var findSuivieBl = await PrixProd.payload.arrayPrixProd;
            var tableRows = findSuivieBl.map((element, key) => (
                <tr key={"pp" + key}>
                    <td>{element.code_article}</td>
                    <td>{element.designation}</td>
                    <td>{element.code_client}</td>
                    <td>{element.client}</td>
                    <td>{element.quantite}</td>
                </tr>
            ));
            setEntities(tableRows);
            setLoader(false)
        },
        [dispatch, location.id]
    );


    const getentete = useCallback(
        async () => {
            var entete = await dispatch(fetchSuivieBlOnly({ id: location.id }));
            var findentete = await entete.payload.findEntete;
            var tableRows = findentete.map((element, key) => (
                <Table bordered hover style={{ textAlign: "center" }}>
                    <thead >
                        <tr>
                            <th>Nom file</th>
                            <th>Mois</th>
                            <th>Année</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{element.namefile}</td>
                            <td>{element.mois}</td>
                            <td>{element.annee}</td>
                        </tr>
                    </tbody>
                </Table>

            ));
            setEntitieTete(tableRows);
        },
        [dispatch, location.id]
    );

    useEffect(() => {
        getSuivieBl();
        getentete();
    }, [getSuivieBl, getentete]);



    function listepp() {
        navigate.push(client + "/listSuivieBl");
    }

    return (
        <>


            <Container fluid>

                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        onClick={listepp}
                    >
                        <span className="btn-label">
                            <i className="fas fa-list"></i>
                        </span>
                        Retour à la liste
                    </Button>
                </Col>
                {loader ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <div>
                        {tete}

                        <hr style={{ borderTop: "4px solid black" }}></hr>

                        <Table bordered hover>
                            <thead className="entete_detail">
                                <tr>
                                    <th>Code Article</th>
                                    <th>Designation</th>
                                    <th>Code client</th>
                                    <th>Client</th>
                                    <th>Valeur</th>
                                </tr>
                            </thead>
                            <tbody>{entities}</tbody>
                        </Table>
                    </div>)}
            </Container>
        </>
    );
}

export default DetailSuivieBl;
